module.exports = __webpack_public_path__ + "static/media/CitiBank.ddcdd4a0.svg";